<template>
  <div class="container-fluid p-0 m-0">
    <div v-if="!hasChildren">
      <div class="container">
      <!-- HEADER -->
      <div class="header row p-0 m-0">
        <div class="col-12 col-lg-6 p-0 m-0">
          <img :src="`${publicPath}img/nuestraActuacion2021.jpg`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive">
        </div>
        <div class="col-12 col-lg-6 text-start px-5 pt-5">
          <h1 class="text-blue mt-3 mb-0">{{ $t('actuacion.nuestra') }}</h1>
          <p>{{ $t('actuacion.ejercicio') }}</p>
        </div>
      </div>
      <!-- end HEADER -->

      <section class="p-0 p-lg-5 pb-lg-0 mx-0 mx-lg-5">

        <div class="row">
          <div class="col-12 col-lg-8 m-auto">
            <div class="container border border-light p-3 m-0 mb-5">
              <h2 class="mt-5 mb-3">{{ $t('actuacion.2021_en_resumen') }}</h2>
              <div class="row">
                <localized-link class="text-end btnPlus" to="/nuestra-actuacion-en-2021/2021-en-resumen"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive">  <strong>{{ $t('literals.vermas') }}</strong></localized-link>
              </div>
            </div>
          </div>
        </div>

        <div class="row px-0 px-lg-5">
          <div class="col-12 col-lg-6 px-0 px-lg-4 mb-5 text-start">
            <img :src="`${publicPath}img/Grupo de desplazamiento 19.jpg`" data-aos="fade-right" data-aos-duration="1000" class="img-responsive mb-3">
            <div class="row px-2 px-lg-0">
              <h4><strong>{{ $t('actuacion.asistencia') }}</strong>
              <localized-link class="text-end btnPlus float-end" to="/nuestra-actuacion-en-2021/asistencia-sanitaria-personalizada"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive"></localized-link>
              </h4>
            </div>
          </div>
          <div class="col-12 col-lg-6 px-0 px-lg-4 mb-5 text-start">
            <img :src="`${publicPath}img/Grupo de desplazamiento 20.jpg`" data-aos="fade-left" data-aos-delay="100" data-aos-duration="1000" class="img-responsive mb-3">
            <div class="row px-2 px-lg-0">
              <h4><strong>{{ $t('actuacion.acciones_prevencion') }}</strong>
              <localized-link class="text-end btnPlus float-end" to="/nuestra-actuacion-en-2021/acciones-de-prevencion"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive"></localized-link>
              </h4>
            </div>
          </div>
        </div>

        <div class="row px-0 px-lg-5">
          <div class="col-12 col-lg-6 px-0 px-lg-4 mb-5 text-start">
            <img :src="`${publicPath}img/Grupo de desplazamiento 21.jpg`" data-aos="fade-right" data-aos-duration="1000" class="img-responsive mb-3">
            <div class="row px-2 px-lg-0">
              <h4><strong>{{ $t('actuacion.tecnologia') }}</strong>
              <localized-link class="text-end btnPlus float-end" to="/nuestra-actuacion-en-2021/tecnologia-al-servicio-de-las-personas"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive"></localized-link>
              </h4>
            </div>
          </div>
          <div class="col-12 col-lg-6 px-0 px-lg-4 mb-5 text-start">
            <img :src="`${publicPath}img/Grupo de desplazamiento 22.jpg`" data-aos="fade-left" data-aos-delay="100" data-aos-duration="1000" class="img-responsive mb-3">
            <div class="row px-2 px-lg-0">
              <h4><strong>{{ $t('actuacion.organizacion') }}</strong>
              <localized-link class="text-end btnPlus float-end" to="/nuestra-actuacion-en-2021/organizacion-y-buen-gobierno"><img :src="`${publicPath}img/btnPlus.png`" class="img-responsive"></localized-link>
              </h4>
            </div>
          </div>
        </div>

      </section>

      <section class="p-0 p-lg-5 py-lg-0 mx-0 mx-lg-5">
        <div class="row">
          <h2 class="my-5">{{ $t('actuacion.esencia') }}</h2>
          <div class="col-12 col-lg-3 px-4 mb-5 mb-lg-0 border-end border-light">
            <img :src="`${publicPath}img/Grupo 340.png`" data-aos="fade-down" data-aos-duration="1000" class="img-responsive mb-3">
            <h3>{{ $t('actuacion.proposito') }}</h3>
            <p class="textSmall text-black">{{ $t('actuacion.socialmente') }}</p>
          </div>
          <div class="col-12 col-lg-3 px-4 mb-5 mb-lg-0 border-end border-light">
            <img :src="`${publicPath}img/Grupo 348.png`" data-aos="fade-down" data-aos-delay="100" data-aos-duration="1000" class="img-responsive mb-3">
            <h3>{{ $t('actuacion.mision') }}</h3>
            <p class="textSmall text-black">{{ $t('actuacion.velar') }}</p>
          </div>
          <div class="col-12 col-lg-3 px-4 mb-5 mb-lg-0 border-end border-light">
            <img :src="`${publicPath}img/Grupo 362.png`" data-aos="fade-down" data-aos-delay="200" data-aos-duration="1000" class="img-responsive mb-3">
            <h3>{{ $t('actuacion.vision') }}</h3>
            <p class="textSmall text-black">{{ $t('actuacion.excelentes') }}</p>
          </div>
          <div class="col-12 col-lg-3 px-4 mb-5 mb-lg-0">
            <img :src="`${publicPath}img/Grupo 377.png`" data-aos="fade-down" data-aos-delay="300" data-aos-duration="1000" class="img-responsive mb-3">
            <h3>{{ $t('actuacion.valores') }}</h3>
            <p class="textSmall text-black" v-html="$t('actuacion.calidad')"></p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg-10 my-5 m-auto">
            <h2 class="myriadPro"><small>{{ $t('actuacion.el_proposito') }}</small></h2>
          </div>
        </div>
      </section>

      <!-- NAVEGACIÓ PRE-FOOTER -->
      <hr>
      <div class="row p-0 g-0 mb-3">
        <div class="col-6 p-0 m-0 pb-3 text-start">
          <localized-link class="footerLink" to="/plan-estrategico"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.plan-estrategico") }}</localized-link>
        </div>
        <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
          <localized-link class="footerLink" to="/nuestra-actuacion-en-2021/2021-en-resumen"> {{ $t("nav.2021-en-resumen") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
        </div>
      </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  props: {
    hasChildren: Boolean
  },
  data() {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>
